export default "__VITE_ASSET__vT6wWY2N__"